// extracted by mini-css-extract-plugin
export default {"container":"UploadMedia_container__+5cPw"};